import { Box, Paper, Stack, Typography } from "@mui/material";
import { formatInteger, formatPercent } from "../../../../../formatters";
import { FunnelStep } from "../../../../../Users/usersApiMapping";

interface UsersFunnelProps {
  steps: FunnelStep[];
  total: number;
}

// Mobile's replacement for the desktop UsersFunnel.tsx - NOT a reuse, unlike
// UsersFunnelDonuts/UsersDonutChart/UsersStepBarSection/UsersStepDonutSection
// (which genuinely stack fine on phone width via their own Grid2 xs:12
// breakpoints). Desktop's version puts label/bar/percentage side by side in
// one row with a fixed 150px label column - that doesn't fit a 390px
// viewport, and isn't "responsive" the way the other reused components are.
// The mockup stacks label+percentage above a full-width track bar per step
// instead. Same underlying bar math (centered fill, opacity gradient) and
// the same text-color/opacity thresholds as desktop (Story 6: "preserve bar
// colors and business logic") - only the outer per-step layout changed.
export default function UsersFunnel({ steps, total }: UsersFunnelProps) {
  const max = Math.max(1, total);

  return (
    <Paper variant="outlined" sx={{ p: "16px 14px", borderColor: "#ececec" }}>
      <Typography sx={{ fontSize: 15, fontWeight: 500, color: "#1a1a1a", mb: 1.75 }}>Main Funnel</Typography>
      <Stack spacing={1.5}>
        {steps.map((step, index) => {
          const widthPercent = (step.count / max) * 100;
          const isLast = index === steps.length - 1;
          const percentOfTotal = total ? (step.count / total) * 100 : 0;

          return (
            <Stack key={step.label} spacing={0.5}>
              <Stack direction="row" alignItems="baseline">
                <Typography sx={{ flex: 1, fontSize: 12.5, color: "#616161" }}>{step.label}</Typography>
                <Typography sx={{ fontSize: 12.5, fontWeight: 600, color: "#8E24AA" }}>
                  {formatPercent(percentOfTotal, 2)}
                </Typography>
              </Stack>
              <Box
                sx={{
                  height: 26,
                  borderRadius: "6px",
                  backgroundColor: "#f3f3f5",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    left: `${(100 - widthPercent) / 2}%`,
                    width: `${widthPercent}%`,
                    height: "100%",
                    backgroundColor: isLast ? "#7CB342" : "#8E24AA",
                    opacity: 0.45 + 0.5 * (1 - index / 12),
                  }}
                />
                <Typography
                  sx={{
                    position: "relative",
                    width: "100%",
                    textAlign: "center",
                    fontSize: 12.5,
                    fontWeight: 700,
                    color: widthPercent > 14 ? "#fff" : "#616161",
                  }}
                >
                  {formatInteger(step.count)}
                </Typography>
              </Box>
            </Stack>
          );
        })}
      </Stack>
    </Paper>
  );
}
